import * as Api from 'features/document/edit/partners/api';
import { showError } from 'actions/actionCreators/snackbarActions';
import { sendHttpRequest } from 'actions/actionCreators/httpActions';
import * as actionTypes from './actionTypes';
import { getVerificationIsLoaded } from './selectors';

export function loadPartnerVerifications(documentId, siteId, partnerId) {
  return async (dispatch, getState) => {
    let { isLoaded } = getVerificationIsLoaded(getState(), partnerId);
    if (isLoaded) {
      return;
    }

    try {
      const partnerVerifications = await dispatch(sendHttpRequest(Api.getDocumentPartnerVerifications(documentId, siteId, partnerId)));

      dispatch({ type: actionTypes.LOAD_PARTNER_VERIFICATIONS_SUCCEEDED, payload: { partnerVerifications } });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadPartnerVerificationsSummary(documentId, siteId, partnerId) {
  return async (dispatch, _getState) => {
    try {
      const verificationsSummary = await dispatch(
        sendHttpRequest(Api.getDocumentPartnerVerificationsSummary(documentId, siteId, partnerId))
      );

      dispatch({ type: actionTypes.LOAD_PARTNER_VERIFICATIONS_SUMMARY_SUCCEEDED, payload: { verificationsSummary, partnerId } });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
